__turbopack_context__.v({
  "badge": "MiniProductCard-module-scss-module__eKnpOa__badge",
  "card": "MiniProductCard-module-scss-module__eKnpOa__card",
  "image": "MiniProductCard-module-scss-module__eKnpOa__image",
  "imagePad": "MiniProductCard-module-scss-module__eKnpOa__imagePad",
  "imageWrapper": "MiniProductCard-module-scss-module__eKnpOa__imageWrapper",
  "info": "MiniProductCard-module-scss-module__eKnpOa__info",
  "link": "MiniProductCard-module-scss-module__eKnpOa__link",
  "name": "MiniProductCard-module-scss-module__eKnpOa__name",
  "originalPrice": "MiniProductCard-module-scss-module__eKnpOa__originalPrice",
  "price": "MiniProductCard-module-scss-module__eKnpOa__price",
  "priceRow": "MiniProductCard-module-scss-module__eKnpOa__priceRow",
  "salePrice": "MiniProductCard-module-scss-module__eKnpOa__salePrice",
  "title": "MiniProductCard-module-scss-module__eKnpOa__title",
});
